import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { usuarioSelector } from '../../store/selectors';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const ultracondominioApiInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const router = inject(Router);
  let usuario$ = store.select(usuarioSelector);

  let reqClone = req;
  usuario$.subscribe(u => {
    reqClone = req.clone({
      setHeaders: {
        Authorization: `Bearer ${u.token}`
      }
    })
  });
  return next(reqClone).pipe(
    catchError((err: any) => {
      console.error(err);
      if (err instanceof HttpErrorResponse) {
        if (err.status === 400 || err.status === 401) {
          router.navigate(['login']);
        }
      }

      return throwError(() => err);
    })
  );
};
